import clsx from 'clsx';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';

import styles from './OverlayShell.module.scss';

interface OverlayShellProps {
  onClose: () => void;
  // -1 for ArrowLeft, 1 for ArrowRight; omit to ignore arrow keys
  onArrowKey?: (direction: -1 | 1) => void;
  maxWidth?: number;
  className?: string;
  children: React.ReactNode;
}

export const OverlayShell = ({ onClose, onArrowKey, maxWidth = 1080, className, children }: OverlayShellProps) => {
  useEffect(() => {
    const html = document.getElementsByTagName('html')[0];
    const previous = html.style.overflow;
    html.style.overflow = 'hidden';

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
        return;
      }
      if (!onArrowKey) return;
      if (event.key === 'ArrowLeft') onArrowKey(-1);
      if (event.key === 'ArrowRight') onArrowKey(1);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      html.style.overflow = previous;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose, onArrowKey]);

  return createPortal(
    <div className={styles.scrim}>
      <div
        className={clsx(styles.box, className)}
        style={{ maxWidth }}
        role="dialog"
        aria-modal="true"
      >
        {children}
      </div>
    </div>,
    document.body,
  );
};
